<template>
    <div>
        <div class="app-body">
            <page-header @openLoginDiolog="openDialog"/>
            <go-back style="padding: 20px" v-if="String($route.query.isShowBack) !== 'false'"/>
            <main class="main-content">
                <h1 class="title">{{ view.title }}</h1>
                <span class="welcome">{{ view.welcome }}</span>
                <question-view v-for="(question) in view.questionList"
                               :key="question.Id"
                               :mode="mode || 'do'"
                               :id="question.Id"
                               ref="question-view"
                               :number="question.type === 'textDesc' ? '' : question.No"
                               :question.sync="question"/>
                <el-button type="primary"
                           @click.stop="handleSubmit"
                           v-if="qid && !userId"
                           style="display: block; width: 90%; margin: 30px auto 0">提交
                </el-button>
            </main>

        </div>
        <bottom-ground/>
        <login-diolog :show.sync="isShowDiolog"/>
    </div>

</template>

<script>
import BottomGround from "@/components/bottomnav";
import PageHeader from "@/components/header";
import QuestionView from "@/components/questionView";
import { formatQuestionnaire, formatBackQuestionnaire } from "@/utils/question-config";
import { submitQuestionnaire, getStudentAnswer } from "@/api/new-question-iteration/question-user"
import { isEmpty } from "@/utils";
import { arrayEquals } from "element-ui/src/utils/util";
import LoginDiolog from "@/components/loginDiolog";
export default {
    name: "DoQuestionnaire",
    components: {
        LoginDiolog,
        BottomGround,
        PageHeader,
        QuestionView
    },
    data() {
        return {
            view: {},
            isShowDiolog: false
        }
    },
    computed: {
        qid () {
            return this.$route.query.Qid
        },
        mode () {
            return this.$route.query.mode
        },
        // 如果有userId就查看学生答案
        userId () {
            return this.$route.query.userId
        }
    },
    created() {
        this.getQuestionnaireDetail()
        this.startTime = new Date().getTime()
    },
    methods: {
        getQuestionnaireDetail() {
            if (this.qid) {
                if (this.userId) {
                    getStudentAnswer(this.qid, this.userId).then(res => {
                        formatBackQuestionnaire(res, (params) => {
                            this.view = params
                            this.tempQuestionList = JSON.parse(JSON.stringify(params.questionList))
                        })
                    })
                } else {
                    formatQuestionnaire(this.qid, (params) => {
                        this.view = params
                        this.tempQuestionList = JSON.parse(JSON.stringify(params.questionList))
                    })
                }
            }
        },
        // 处理提交
        handleSubmit() {
            if (!this.qid) return
            const { questionList, GuestUserId } = this.view
            if (arrayEquals(this.tempQuestionList, questionList)) {
                return this.$message.warning("请填写问卷")
            }
            let isAlert = false
            questionList.forEach((item, index) => {
                if (item.required && isEmpty(item.answer)) {
                    this.$refs["question-view"][index].setErrorTip(true)
                    isAlert = true
                }
            })
            if (isAlert) return this.$message.warning("请填写必填题（带*号）")
            const Answers = questionList.map(item => {
                const { answer, Id } = item
                return {
                    QuestionnaireDetailId: Id,
                    Answer: Array.isArray(answer) ? answer.join("|") : answer
                }
            })
            submitQuestionnaire({
                Answers,
                QuestionnaireId: this.qid,
                TimeLength: parseInt((new Date().getTime() - this.startTime) / 1000),
                GuestUserId: GuestUserId
            }).then(res => {
                this.$message.success("作答成功")
                if (GuestUserId) {
                    // 匿名用户是不能查看统计结果的
                    this.$route.query.isViewResult = 0
                }
                // 跳转到问卷结果页
                this.$router.push({
                    name: "QuestionResult",
                    query: {
                        Qid: this.qid,
                        isViewResult: this.$route.query.isViewResult,
                        from: this.$route.query.from
                    }
                })
            })
        },
        openDialog () {
            this.isShowDiolog = true
        },
    },
}
</script>

<style scoped lang="less">
.main-content {
    background-color: #fff;
    padding: 30px 60px;
    margin-bottom: 30px;

    .title {
        text-align: center;
        margin: 20px 0;
    }

    .welcome {
        font-size: 16px;
        font-weight: 500;
        padding-left: 30px;
    }
}
</style>
